module.exports = __webpack_public_path__ + "static/media/S_F03.1bfd21f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/RED/S_F03.png
// module id = 134
// module chunks = 0